module.exports = __webpack_public_path__ + "media/images/meta/stretchlab/favicon-63cd029bcdb12efb9c530a1aefd966b7.png";